import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useNCWBalance } from '@capsicum/socios-core';
import { useParams } from 'next/navigation';
import { useCallback } from 'react';

/**
 * This Guard denies the access when partnerShortCode parameter does not exist or the user does not own any asset by
 * the name of partnerShortCode.
 * @returns {Guard} Guard type compliant result
 */
export const useNCWPartnerDetailsGuard: Guard = () => {
	const { replace } = useRouter();
	const { getTokenBalanceBy, isPending } = useNCWBalance();
	const params = useParams();
	const tokenShortCode = params?.partnerShortCode;

	const onDenied = useCallback(() => replace('/nc-wallet'), [replace]);

	const getStatus = () => {
		if (!tokenShortCode) return 'denied';

		if (Array.isArray(tokenShortCode) && tokenShortCode.length === 0) return 'denied';

		if (isPending) return 'loading';

		if (!getTokenBalanceBy(tb => tb.shortCode === tokenShortCode)) return 'denied';

		return 'allowed';
	};

	return {
		onDenied,
		status: getStatus()
	};
};
